import { ActionWithErrorBadge } from '@makemydeal/dr-dash-components';
import { NumericInput } from '@makemydeal/dr-shared-components/numeric-input';

import { useTradeAllowanceField } from '../../../../baseDealActivity/baseDealContainer/TradeInFields/useTradeAllowanceField';
import { useScenarioCellId } from '../../../hooks/useScenarioCellId';
import { RowLabelAction } from '../../RowLabelAction';
import { ScenarioRow } from '../../ScenarioRow';

export const TradeAllowanceRow = () => {
    const { label, errorBadgeEntity, onLabelActivate, inputProps } = useTradeAllowanceField();
    const inputId = useScenarioCellId('tradeAllowance');

    return (
        <ScenarioRow
            rowKey="tradeAllowance"
            label={
                <RowLabelAction onActivate={onLabelActivate} testId="trade-allowance-input-label">
                    <ActionWithErrorBadge entityName={errorBadgeEntity}>{label}</ActionWithErrorBadge>
                </RowLabelAction>
            }
        >
            <NumericInput {...inputProps} id={inputId} label={label} displayLabel={false} />
        </ScenarioRow>
    );
};
